"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustoType = void 0;
var CustoType;
(function (CustoType) {
    CustoType["component"] = "c";
    CustoType["data"] = "d";
    CustoType["hook"] = "h";
    CustoType["text"] = "t";
})(CustoType = exports.CustoType || (exports.CustoType = {}));
